import script from "./CourtBookingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtBookingPage.vue?vue&type=script&setup=true&lang=js"

import "./CourtBookingPage.vue?vue&type=style&index=0&id=bba8d3b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba8d3b6"]])

export default __exports__